export default __webpack_public_path__ + "static/media/fleshtoworms.659f2bfc.png";